import React, { useState, useEffect } from "react";
import axios from "axios";

const Sidebar = ({ onSelectDepartment , selectedDepartment}) => {
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        axios.get("https://nhniapp.in/webapi/spls/splslist1db.php?action=departments")
            .then(response => setDepartments(response.data))
            .catch(error => console.error("Error fetching departments", error));
    }, []);

    return (
        <div className="bg-dark text-white p-3" style={{ width: "250px", background: "#ddd", padding: "10px" }}>
            <h4 className="text-center">Departments</h4>
            <ul className="list-group">
                {departments.map(dept => (
                    <li key={dept.splid}
                      
                        className={`list-group-item list-group-item-action ${selectedDepartment === dept.splid ? "active" : ""}`}
                        onClick={() => onSelectDepartment(dept.splid)}
                        style={{ cursor: "pointer" }}>
                        {dept.splname}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Sidebar;
